const traumaContent = {
"trauma-id": {
  title: "Orthopaedic Trauma",
  sections: [
    {
      type: "text",
      content: `
        <h4 class="kneePartsTitle">Orthopaedic Trauma</h4>

        <p>
          Orthopaedic trauma refers to injuries affecting bones, joints, and surrounding soft tissues.  
          It can result from falls, road traffic accidents, sports injuries, or sudden unexpected impact.  
          Proper and timely treatment helps prevent long-term complications and ensures better recovery.
        </p>

        <h4 class="kneePartsTitle">Nature of Injury Depends On:</h4>
        <ul>
          <li>Force and impact of trauma</li>
          <li>Age</li>
          <li>Sex (females are more prone towards osteoporotic bones)</li>
          <li>Bone health</li>
          <li>Muscle strength</li>
          <li>Joint health</li>
        </ul>

        <h4 class="kneePartsTitle">Most Common Trauma Injuries by Age Group</h4>
        <ul>
          <li>Paediatric age — elbow and wrist fracture</li>
          <li>Young age — shin bone (tibia) fractures</li>
          <li>Old age — hip fracture, fracture neck femur, vertebral fractures</li>
        </ul>

        <h4 class="kneePartsTitle">Management</h4>
        <ul>
          <li>Early intervention to prevent complications like malunion, nonunion, septic arthritis in open wounds</li>
          <li>Surgical procedure as per requirement</li>
          <li>Mobilization and physiotherapy post-surgery</li>
        </ul>

        <p>
          Orthopaedic trauma treatment is highly individualized and depends on injury severity, bone quality, and patient health.  
          Early diagnosis and prompt management significantly improve outcomes.
        </p>

        <p>
          Talk to <strong>Dr. Sachin Karkamkar, Hadapsar, Pune</strong> for complete evaluation and personalized trauma care.
        </p>
      `
    }
  ]
}
}
export default traumaContent;